import Vue, { Component } from 'vue'

export type DesktopModalType = 'modal' | 'hidden'

export type MobileModalType = 'full-screen' | 'drawer' | 'hidden'

export interface ModalOptions {
  desktop?: DesktopModalType
  mobile?: MobileModalType
  component: Component
  name: string
  title?: string
  size?: 'sm' | 'md' | 'lg'
  onClose?: ModalCloseHandlerFn
  closeable?: boolean
  props?: Dict<any>
}

export type ModalCloseHandlerFn = (data?: any) => void

export function getNormalizedModalOptions(options: Partial<ModalOptions>): Required<ModalOptions> {
  const defaults: Partial<ModalOptions> = {
    name: '',
    size: 'lg',
    closeable: true,
    onClose() {},
    desktop: 'modal',
    mobile: 'drawer',
  }

  return { ...defaults, ...options } as Required<ModalOptions>
}

export function openModal(options: ModalOptions) {
  Vue.prototype.$modals.$emit('new:modal', options)
}
